import { useId } from "react";
import { SvgProps } from "components/icons/types";

export const Thread = (props: SvgProps) => {
  const clipPathId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M1.00342 11.9998H0.00341797V7.99981C0.00434337 6.80723 0.478266 5.6637 1.32122 4.82009C2.16418 3.97648 3.30734 3.50167 4.49992 3.49982L6.92142 3.42282V0.21582L11.5649 4.86232C11.8461 5.14361 12.0041 5.52507 12.0041 5.92281C12.0041 6.32056 11.8461 6.70202 11.5649 6.98331L6.92242 11.6298V8.42281L4.49992 8.49981C3.57251 8.50153 2.68363 8.87094 2.02818 9.52705C1.37273 10.1832 1.00421 11.0724 1.00342 11.9998V11.9998ZM4.50342 7.49981L7.92442 7.42281V9.21581L10.8614 6.27631C10.9552 6.18255 11.0078 6.0554 11.0078 5.92281C11.0078 5.79023 10.9552 5.66308 10.8614 5.56931L7.92192 2.62982V4.42282L4.49992 4.49982C3.5719 4.50061 2.68213 4.86961 2.02592 5.52582C1.36972 6.18202 1.00071 7.0718 0.999918 7.99981V9.17431C1.42097 8.65125 1.95399 8.22929 2.55971 7.93949C3.16543 7.6497 3.82844 7.49945 4.49992 7.49981H4.50342Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
